import React from "react";

import HairCareProducts from "./HairCareProducts.jsx";
import MedicaEngg from "./MedicalEnggProducts.jsx";
import BredcrumpImage from "../assets/images/skin-breadcrum.jpg";
import BreadcrumbSection from "./BreadcrumbSection";



const Products = () => {
  return (
    <>
      <BreadcrumbSection
        title="Redefining Healthcare with Precision and Passion."
        subtitle="Committed to Excellence:"
        breadcrumbItems={[
          { label: "Home", to: "/" },

        ]}
        backgroundImage={BredcrumpImage}
      />
      <MedicaEngg />
    </>
  );


};

export default Products;
